import { type CSSProperties } from 'react';

import { FONT_INTER, PAGE_BODY_PADDING } from '../shared/blueprint-view-styles';

export const FLAT_TRIM_BODY_STYLE: CSSProperties = {
	flex: 1,
	position: 'relative',
	display: 'flex',
	flexDirection: 'column',
	overflow: 'hidden',
	minHeight: 0,
	padding: PAGE_BODY_PADDING
};

// the pieces stay centred on the sheet, so the note column floats over the upper-left instead of taking a column
export const FLAT_TRIM_NOTES_STYLE: CSSProperties = {
	position: 'absolute',
	top: 0,
	left: 0,
	zIndex: 1,
	maxWidth: '300px',
	fontFamily: FONT_INTER,
	fontSize: '14px',
	fontWeight: 400,
	lineHeight: '1.4'
};

export const FLAT_TRIM_NOTE_LABEL_STYLE: CSSProperties = { fontWeight: 700 };

export const FLAT_TRIM_VIEWPORT_STYLE: CSSProperties = {
	flex: 1,
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center',
	overflow: 'hidden',
	minHeight: 0,
	clipPath: 'inset(0)'
};

export const FLAT_TRIM_EMPTY_STYLE: CSSProperties = {
	fontSize: '14px',
	color: '#999',
	margin: 'auto'
};

export const FLAT_TRIM_FOOTER_STYLE: CSSProperties = {
	flexShrink: 0,
	display: 'flex',
	flexDirection: 'column',
	gap: '14px'
};
